import React, { Component } from 'react';
import Documented from 'components/help/Documented.js';
import Colors from 'components/Colors.js';
import ConditionedComponent from 'components/ConditionedComponent.js';
import Dropdown from 'react-dropdown';
import Resolution from 'engine/Resolution.js';
import { connect } from "react-redux";
import {setParameterToMap} from "actions/index.js";

const colors = new Colors();

class ResolutionDropdown extends Component {
    hasAutomationSet() {
        if (this.props.automation !== undefined) {
            let parameterFuture = this.props.automation.get(this.props.parameter);
            return parameterFuture !== undefined;
        }
        return false;
    }

    deleteAutomation() {
        this.props.automation.delete(this.props.parameter);
    }

    getMacroOverlayIfNeeded() {
        let {isMacroMapping, parameter, isParameterToMap} = this.props;
        if (isMacroMapping && parameter) {
            let className = "macro-overlay";
            if (isParameterToMap) {
                className += " parameter-to-map";
            }

            if (parameter.hasMacro) {
                className += " mapped";
            }

            let style = {
            };

            if (this.props.parameter.hasMacro) {
                style = {
                    backgroundColor: colors.getColorForHash(parameter.hasMacro.id)
                };
            }

            let text = parameter.hasMacro && parameter.hasMacro.name;

            return (
                <div
                  onClick={() => this.props.setParameterToMap(this.props.parameter)}
                  className={className}>
                  <div className="overlay-main"></div>
                  <div className="overlay-detail" style={style}>
                    {text}
                  </div>
                </div>
            );
        }

        return '';
    }

    render() {
        let value = getResolutionOption(this.props.value);
        let className = "lfo-rate-dropdown";

        return (
            <Documented element={this.props.parameter}
              onClick={() => this.props.setParameterToMap(this.props.parameter)}
              className="lfo-rate-dropdown">
              {this.getMacroOverlayIfNeeded()}
              {this.props.hideLabel ? '' :
                  <div className="lfo-rate-label">
                        Rate:
                  </div>}
              <Dropdown
                className='osc-type-dropdown float-left'
                controlClassName='osc-type-control-dropdown'
                arrowClassName='osc-type-arrow-dropdown'
                options={resolutionOptions}
                onChange={(o) => this.props.onChange(o.value)}
                value={getResolutionOption(this.props.value)}
                placeholder="Rate" />
                <ConditionedComponent condition={this.hasAutomationSet()}>
                  <div
                    onClick={() => this.deleteAutomation()}
                    className="automation-label float-right">AUTOMATION</div>
                </ConditionedComponent>
                <div className="clear-fix"/>
            </Documented>
        );
    }
}

const resolutionOptions = [
    {value: new Resolution(4, false), label:'1/4'},
    {value: new Resolution(4, true), label:'1/4t'},
    {value: new Resolution(8, false), label:'1/8'},
    {value: new Resolution(8, true), label:'1/8t'},
    {value: new Resolution(16, false), label:'1/16'},
    {value: new Resolution(16, true), label:'1/16t'},
    {value: new Resolution(32, false), label:'1/32'},
    {value: new Resolution(32, true), label:'1/32t'},
];

function getResolutionOption(value) {
    for (var i=0; i < resolutionOptions.length; i++) {
        if (resolutionOptions[i].value.resolution == value.resolution &&
           resolutionOptions[i].value.isTriplet == value.isTriplet) {
            return resolutionOptions[i];
        }
    }
    return null;
}

const mapStateToProps = (state, props) => {
    let value = 
        props.automation === undefined ||
        props.automation.get(props.parameter) === undefined
        ? props.parameter.get() :
        props.automation.get(props.parameter).value;

    return {
        value: value,
        isMacroMapping: state.effects.isMacroMapping,
        isParameterToMap: props.parameter &&
            state.effects.parameterToMap === props.parameter 
    };
}

const mapDispatchToProps = dispatch => {
    return {
        setParameterToMap: parameter => dispatch(setParameterToMap(parameter)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ResolutionDropdown);
